module.exports = __webpack_public_path__ + "img/pumping-activities-role4.280c0619.png";